import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({ selector: '[appInputTrim]' })
export class InputTrimDirective {
  constructor(private el: ElementRef, @Optional() private ngControl: NgControl) {}

  @HostListener('blur') onBlur() {
    const value = this.ngControl.control?.value;
    if (typeof value === 'string') {
      const trimmed = value.trim();
      this.ngControl.control?.setValue(trimmed);
    }
  }
}
